import { render, staticRenderFns } from "./authority-add.vue?vue&type=template&id=4c14bf6a&scoped=true"
import script from "./authority-add.vue?vue&type=script&lang=js"
export * from "./authority-add.vue?vue&type=script&lang=js"
import style0 from "./authority-add.vue?vue&type=style&index=0&id=4c14bf6a&prod&scoped=true&lang=scss"
import style1 from "./authority-add.vue?vue&type=style&index=1&id=4c14bf6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c14bf6a",
  null
  
)

export default component.exports